import { render, staticRenderFns } from "./archiveStatus.vue?vue&type=template&id=9316e988&scoped=true"
import script from "./archiveStatus.vue?vue&type=script&lang=js"
export * from "./archiveStatus.vue?vue&type=script&lang=js"
import style0 from "./archiveStatus.vue?vue&type=style&index=0&id=9316e988&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9316e988",
  null
  
)

export default component.exports